import { h, Component } from 'preact';

export default class Home extends Component {
  componentDidMount() {
    [].map.call(this.ref.querySelectorAll('nav > a'), (a) => {
      // me no work
      const image = window.getComputedStyle(a, ':before').backgroundImage;
    });

    setTimeout(() => {
      this.ref.classList.remove('loading');
    }, 1000);
  }

  render() {
    return (
      <section class="home loading" ref={ (el) => this.ref = el }>
        <nav class="flex flex-wrap">
          <a href="/book">
            <h2>Book a Session</h2>
          </a>
          <a href="/contact">
            <h2>Contact</h2>
          </a>
          <a href="/testimonials">
            <h2>Testimonials</h2>
          </a>
          <a href="/about">
            <h2>About</h2>
          </a>
        </nav>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./components/home.js